/** 室内設備として表示しない basicAmenity 名 */
const INDOOR_EQUIPMENT_EXCLUDED_NAMES = new Set(["焚き火台"]);

/**
 * `architectureType.content.basicAmenities` から室内設備の表示テキストを生成する。
 * - 「焚き火台」など室内設備として扱わない amenity を除外
 * - 「・」で連結 (例: "エアコン・バスルーム・洗濯乾燥機付き")
 * - 該当 amenity が無ければ `undefined` を返し、呼び出し側で行ごと非表示にできる
 */
export function buildIndoorEquipmentText(
  basicAmenities: ReadonlyArray<{ name: string }>,
): string | undefined {
  const filtered = basicAmenities
    .filter((a) => !INDOOR_EQUIPMENT_EXCLUDED_NAMES.has(a.name))
    .map((a) => a.name);
  return filtered.length > 0 ? filtered.join("・") : undefined;
}
